import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/hydra-error')({
  staticData: { team: 'users-infra' },
});
